"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ToggleButton extends HTMLButtonElement {
    constructor() {
        super();
        const targetId = this.getAttribute('aria-controls');
        if (!targetId) {
            throw new Error('The "aria-controls" attribute is required.');
        }
        const target = document.getElementById(targetId);
        if (target === null) {
            throw new Error(`The "${targetId}" attribute does not exist.`);
        }
        this.target = target;
        this.addEventListener('click', () => this.toggle());
    }
    toggle() {
        this.target.hidden = !this.target.hidden;
    }
}
exports.default = ToggleButton;
